export default __webpack_public_path__ + "static/media/f6.3ef70561.svg";